module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("5R3UF"))).then(() => module.bundle.root('37nVf'));